// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

var swiper = new Swiper(".slider-hero", {
    effect: "fade",
    speed: 3000,
    loop: true,
    pagination: {
        el: ".slider-pagination",
        clickable: true,
    },
    autoplay: {
        delay: 5000,
        disableOnInteraction: true,
    },
});